var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('a',{attrs:{"href":"http://istay.io","target":_vm.target}},[_c('img',{attrs:{"src":require("@/assets/images/istay-orange-text.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }